// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Lato_300.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Lato_400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Lato_700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Lato_900.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'Lato';
	font-style: normal;
	font-weight: 300;
	src:
		/* from https://fonts.gstatic.com/s/lato/v17/S6u9w4BMUTPHh7USSwiPGQ.woff2 */
		url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}
@font-face {
	font-family: 'Lato';
	font-style: normal;
	font-weight: 400;
	src:
		/* from https://fonts.gstatic.com/s/lato/v17/S6uyw4BMUTPHjx4wXg.woff2 */
		url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}
@font-face {
	font-family: 'Lato';
	font-style: normal;
	font-weight: 700;
	src:
		/* from https://fonts.gstatic.com/s/lato/v17/S6u9w4BMUTPHh6UVSwiPGQ.woff2 */
		url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}
@font-face {
	font-family: 'Lato';
	font-style: normal;
	font-weight: 900;
	src:
		/* from https://fonts.gstatic.com/s/lato/v17/S6u9w4BMUTPHh50XSwiPGQ.woff2 */
		url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
}

html, body, #app {
    height: 100%;
    max-height: 100%;
    position: relative;
    overflow: hidden;
}

#app {
    font-family: "Lato", sans-serif;
    font-size: 18px;
    color: #464646;
}

body {
    overflow: hidden;
}

.table > thead > tr > th {
    border-bottom: 0;
    padding: 12px;
    vertical-align: top;
}

.table > tbody > tr > td {
    border-top: 0;
    padding: 8px;
    vertical-align: middle;
}
.table{
    position: relative;
}

label {
    font-weight: normal;
}

select > option:hover,
select > option:focus,
select > option:checked {
    box-shadow: 0 0 10px 100px #248fdf inset;
}

input[type=email],
input[type=file],
input[type=text],
input[type=password],
input[type=date],
input[type=datetime-local],
input[type=number] {
    width: 60%;
    padding-left: 10px;
    padding-bottom: 5px;
    padding-bottom: 5px;
    border: 0;
    outline: 0;
    border-bottom: 2px solid #efefef;
    font-size: 18px;
    font-style: regular;
    color: #248fdf;
}

input[type=text]:disabled {
    background-color: #efefef;
}

input:focus,
input.filled,
textarea.filled {
    border-color: #248fdf;
}

/* 
 * Gestion du focus :
 * - Chrome applique un outline par défaut au clic sur boutons/liens (effet visuel indésirable)
 * - On le supprime pour les interactions souris
 * - MAIS on conserve un indicateur visible pour la navigation clavier via :focus-visible (accessibilité)
 */
button:focus,
a:focus {
    outline: none;
}
:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px rgba(36, 143, 223, 0.4);
}

input::placeholder {
    color: #efefef;
}

input:invalid {
    box-shadow: none;
}

button.transparent {
    border: 0;
    background-color: inherit;
}

.valid-color {
    color: #61bd4f;
}

.margin-top-10 {
    margin-top: 10px;
}

.no-margin-bottom {
    margin-bottom: 0 !important;
}

.margin-bottom-form {
    margin-bottom: 5rem;
}

.alert h3 {
    margin-top: 0;
    margin-bottom: 20px;
}

.with-pointer {
    cursor: pointer;
}

.relative-container {
    position: relative;
}

.margin-bottom-40 {
    margin-bottom: 40px;
}

.clearfix {
    clear: left;
    display: block;
}

.bold{
    font-weight: bold;
}

.wording{
    font-size: smaller;
    font-style: italic;
    margin-left: 3rem;
    margin-top: -2rem;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB;;yDAE+C;AAChD;AACA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB;;yDAE+C;AAChD;AACA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB;;yDAE+C;AAChD;AACA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB;;yDAE+C;AAChD;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;;;;;;;IAOI,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;;;;EAKE;AACF;;IAEI,aAAa;AACjB;AACA;IACI,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB","sourcesContent":["@font-face {\n\tfont-family: 'Lato';\n\tfont-style: normal;\n\tfont-weight: 300;\n\tsrc:\n\t\t/* from https://fonts.gstatic.com/s/lato/v17/S6u9w4BMUTPHh7USSwiPGQ.woff2 */\n\t\turl('../fonts/Lato_300.woff2') format('woff2');\n}\n@font-face {\n\tfont-family: 'Lato';\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc:\n\t\t/* from https://fonts.gstatic.com/s/lato/v17/S6uyw4BMUTPHjx4wXg.woff2 */\n\t\turl('../fonts/Lato_400.woff2') format('woff2');\n}\n@font-face {\n\tfont-family: 'Lato';\n\tfont-style: normal;\n\tfont-weight: 700;\n\tsrc:\n\t\t/* from https://fonts.gstatic.com/s/lato/v17/S6u9w4BMUTPHh6UVSwiPGQ.woff2 */\n\t\turl('../fonts/Lato_700.woff2') format('woff2');\n}\n@font-face {\n\tfont-family: 'Lato';\n\tfont-style: normal;\n\tfont-weight: 900;\n\tsrc:\n\t\t/* from https://fonts.gstatic.com/s/lato/v17/S6u9w4BMUTPHh50XSwiPGQ.woff2 */\n\t\turl('../fonts/Lato_900.woff2') format('woff2');\n}\n\nhtml, body, #app {\n    height: 100%;\n    max-height: 100%;\n    position: relative;\n    overflow: hidden;\n}\n\n#app {\n    font-family: \"Lato\", sans-serif;\n    font-size: 18px;\n    color: #464646;\n}\n\nbody {\n    overflow: hidden;\n}\n\n.table > thead > tr > th {\n    border-bottom: 0;\n    padding: 12px;\n    vertical-align: top;\n}\n\n.table > tbody > tr > td {\n    border-top: 0;\n    padding: 8px;\n    vertical-align: middle;\n}\n.table{\n    position: relative;\n}\n\nlabel {\n    font-weight: normal;\n}\n\nselect > option:hover,\nselect > option:focus,\nselect > option:checked {\n    box-shadow: 0 0 10px 100px #248fdf inset;\n}\n\ninput[type=email],\ninput[type=file],\ninput[type=text],\ninput[type=password],\ninput[type=date],\ninput[type=datetime-local],\ninput[type=number] {\n    width: 60%;\n    padding-left: 10px;\n    padding-bottom: 5px;\n    padding-bottom: 5px;\n    border: 0;\n    outline: 0;\n    border-bottom: 2px solid #efefef;\n    font-size: 18px;\n    font-style: regular;\n    color: #248fdf;\n}\n\ninput[type=text]:disabled {\n    background-color: #efefef;\n}\n\ninput:focus,\ninput.filled,\ntextarea.filled {\n    border-color: #248fdf;\n}\n\n/* \n * Gestion du focus :\n * - Chrome applique un outline par défaut au clic sur boutons/liens (effet visuel indésirable)\n * - On le supprime pour les interactions souris\n * - MAIS on conserve un indicateur visible pour la navigation clavier via :focus-visible (accessibilité)\n */\nbutton:focus,\na:focus {\n    outline: none;\n}\n:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(36, 143, 223, 0.4);\n}\n\ninput::placeholder {\n    color: #efefef;\n}\n\ninput:invalid {\n    box-shadow: none;\n}\n\nbutton.transparent {\n    border: 0;\n    background-color: inherit;\n}\n\n.valid-color {\n    color: #61bd4f;\n}\n\n.margin-top-10 {\n    margin-top: 10px;\n}\n\n.no-margin-bottom {\n    margin-bottom: 0 !important;\n}\n\n.margin-bottom-form {\n    margin-bottom: 5rem;\n}\n\n.alert h3 {\n    margin-top: 0;\n    margin-bottom: 20px;\n}\n\n.with-pointer {\n    cursor: pointer;\n}\n\n.relative-container {\n    position: relative;\n}\n\n.margin-bottom-40 {\n    margin-bottom: 40px;\n}\n\n.clearfix {\n    clear: left;\n    display: block;\n}\n\n.bold{\n    font-weight: bold;\n}\n\n.wording{\n    font-size: smaller;\n    font-style: italic;\n    margin-left: 3rem;\n    margin-top: -2rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
